import HttpClient from 'httpClient';

export function getContent(slug) {
  return HttpClient.get(`/wp-json/wp/v2/pages?slug=${slug}`);
}
